var $  = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');

var fixLoaded = false;

function disableButton(button) {
  if (!button.hasClass('waiting') && button.is('#start-part-count-fix')) {
    button.addClass('waiting');
    button.removeAttr('data-sw-noty');
  }
  else if (!button.hasClass('waiting') && button.is('#sintershell-proceed')) {
    button.addClass('sw--is-disabled');
    button.addClass('waiting');
  }
}

function enableButton(button) {
  if (button.hasClass('waiting') && button.is('#start-part-count-fix')) {
    button.removeClass('waiting');
    button.attr('data-sw-noty', '');
  }
}

function showAfterModel() {
  $('#automated-printability-checks-asset-aopt-pc-iframe').hide();
  $('#part-count-fix-after-iframe').show();
}

function loadNewPCenter() {
  var newModelVersion = parseInt(sw.data.legacyData.fixPartCount.modelVersion, 10) + 1;
  //now its a new version
  window.location.href = '/model/3dtools/' + parseInt(sw.data.legacyData.fixPartCount.modelId, 10) +
    '/' + newModelVersion +
    '/' + parseInt(sw.data.legacyData.fixPartCount.materialId, 10);
}

function saveAndExit() {
  //Save
  var fixButton = $('#start-part-count-fix');
  fixButton.addClass('waiting');
  var params = {
    'modelVersion': sw.data.legacyData.fixPartCount.modelVersion,
    'modelId':      sw.data.legacyData.fixPartCount.modelId,
    'materialId':   sw.data.legacyData.fixPartCount.materialId
  };
  $.post('/model/edit/save-part-count-fix', params, function () {
    loadNewPCenter();
  });
}

function endFixPartCount() {
  if (fixLoaded) {
    return;
  } else {
    fixLoaded = true;
  }
  var fixButton = $('#start-part-count-fix');
  fixButton.text('save and exit');
  fixButton.on('click', saveAndExit);
  fixButton.removeClass('waiting');

  var loadingBar = $('.printability-center-progress-indicator');
  loadingBar.hide();

  $('#download-part-count-fix').show();
  var params = {
    'materialId':  sw.data.legacyData.fixPartCount.materialId,
    'modelFileId': sw.data.legacyData.fixPartCount.modelFileId,
    'bClass':      sw.data.legacyData.fixPartCount.bClass,
    'key':         sw.data.legacyData.fixPartCount.secretKey,
    'width':       '959',
    'height':      '446'
  };
  $.post('/model/edit/part-count-after-fix-viz', params, function (response) {
    $('#automated-printability-checks-asset-aopt-pc-iframe').after(response);
    $('.part-count-fix-model-toggle').show();
    showAfterModel();
  });
}

function showFixedPrice() {
  var oldPrice = $('#price');
  if (oldPrice) {
    $('.part-count-fix-pricing').show();
    $('#before-fix-price').css('text-decoration', 'line-through');
  }
}

function showFixedShells() {
  $('#before-fix-shells').css('text-decoration', 'line-through');
}

function showFixing() {
  var fixButton = $('#start-part-count-fix');
  disableButton(fixButton);

  var loadingBar = $('.printability-center-progress-indicator');
  loadingBar.show();
}

function checkFixStatus() {
  var params = {
    'modelVersion': sw.data.legacyData.fixPartCount.modelVersion,
    'modelFileId':  sw.data.legacyData.fixPartCount.modelFileId,
    'modelId':      sw.data.legacyData.fixPartCount.modelId,
    'materialId':   sw.data.legacyData.fixPartCount.materialId
  };
  $.post('/model/edit/check-part-count-fix', params, function (response) {
    response = window.JSON.parse(response);
    if (response.success) {
      if (response.status === sw.data.legacyData.fixPartCount.statusFixedAssetExits) {
        endFixPartCount();
        showFixedPrice();
        showFixedShells();
      } else if (response.status === sw.data.legacyData.fixPartCount.statusNotFixed) {
        var fixButton = $('#start-part-count-fix');
        enableButton(fixButton);
        var loadingBar = $('.printability-center-progress-indicator');
        loadingBar.hide();
      } else {
        showFixing();
        setTimeout(checkFixStatus, 2500);
      }
    }
  });
}

$(function () {
  var fixButton = $('#start-part-count-fix');
  disableButton(fixButton);
  checkFixStatus();
});

function startFixPartCount() {
  showFixing();
  var params = {
    'modelVersion': sw.data.legacyData.fixPartCount.modelVersion,
    'modelFileId':  sw.data.legacyData.fixPartCount.modelFileId,
    'modelId':      sw.data.legacyData.fixPartCount.modelId,
    'materialId':   sw.data.legacyData.fixPartCount.materialId
  };
  $.post('/model/edit/start-part-count-fix', params, function (response) {
    response = window.JSON.parse(response);
    if (response.success === true) {
      setTimeout(checkFixStatus, 2500);
    }
  });
}

window.confirmed = function confirmed(proceedButton) {
  var $proceedButton = $(proceedButton);
  if(!$proceedButton.hasClass('sw--is-disabled')) {
    startFixPartCount();
    disableButton($proceedButton);
  }
};

window.downloadFixes = function downloadFixes() {
  window.location.href =
    '/model/edit/download-part-count-fix?' +
    'modelVersion' +
    '=' + sw.data.legacyData.fixPartCount.modelVersion + '&' +
    'modelId' +
    '=' + sw.data.legacyData.fixPartCount.modelId + '&' +
    'materialId' +
    '=' + sw.data.legacyData.fixPartCount.materialId;
};

